import store from 'store2'

const walkthroughStore = store.namespace('walkthrough')
const analyticsStore = store.namespace('analytics')
const engagementChannelStore = store.namespace('engagementChannels')
const guestCartStore = store.namespace('guestCart')

export { analyticsStore, engagementChannelStore, walkthroughStore, guestCartStore }
